"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextAreaRoot = exports.LINE_HEIGHT_PX = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _withFocusClassName = require("../../../util/withFocusClassName");
var _TextInputRootBox = require("../../textinput/styled/TextInputRootBox");
var _formInputTheme = require("../../textinput/styled/formInputTheme");
var _constants = require("../constants");
// This is used to derive the fact that a 4 line textarea with
// box-sizing: border-box is exactly 94px high, so we can avoid
// magic numbers.
const LINE_HEIGHT_PX = 18;
exports.LINE_HEIGHT_PX = LINE_HEIGHT_PX;
const StyledTextAreaRoot = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)(_TextInputRootBox.TextInputRootBox)`
    justify-content: space-between;
    height: auto;
    position: relative;
    padding: 0px;
    width: 100%;
    align-items: flex-start;
    padding-right: var(--smar--sds--textarea--wrapper--padding-right, 4px);
    padding-top: var(--smar--sds--textarea--wrapper--padding-top, 0px);
    padding-left: var(--smar--sds--textarea--wrapper--padding-left, 0px);
    padding-bottom: var(--smar--sds--textarea--wrapper--padding-bottom, 0px);
    transition: background-color 100ms ${_designTokens.motion.easing.default};
    color: ${_ref => {
  let {
    themeMode,
    isDisabled
  } = _ref;
  return isDisabled ? _formInputTheme.formInputTheme.textColor.readonly(themeMode) : _formInputTheme.formInputTheme.textColor.rest(themeMode);
}};

    textarea,
    div.${_constants.GROW_WRAPPER_CLASS} {
        font-size: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _formInputTheme.formInputTheme.fontSize.box(themeMode);
}};
        font-weight: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _formInputTheme.formInputTheme.fontWeight(themeMode);
}};
        line-height: ${LINE_HEIGHT_PX}px;
        font-family: inherit;
        border: none;
        grid-area: 1 / 1 / -1 / -1;
        white-space: pre-wrap;
        width: 100%;
        word-break: break-word;
        font: inherit;
        // necessary for firefox bug that adds 1px margin top/bottom, hiding the bottom border
        margin: 0;
        overflow-y: auto;
        box-sizing: border-box;
        border-radius: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _formInputTheme.formInputTheme.borderRadius(themeMode);
}};
        &:focus {
            outline: none;
        }
        ::-webkit-scrollbar-track {
            margin-top: 4px;
            margin-bottom: 4px;
        }
    }
`);
exports.StyledTextAreaRoot = StyledTextAreaRoot;
//# sourceMappingURL=StyledTextAreaRoot.js.map